<template>
	<v-content
		app
		v-bind:class="{ 'window-a': windowWidth, 'window-b': !windowWidth }"
	>
		<router-view v-if="ready" />

		<core-footer />
	</v-content>
</template>

<script>
export default {
	name: "CoreView",
	data: () => ({
		ready: Boolean,
	}),
	async beforeMount() {
		this.ready = false;
		let userInfo = await this.$extractions.getUserInfo();
		this.$store.commit("setUserInfo", userInfo.data);
		this.ready = true;
		if (
			this.$router.currentRoute.path.includes("/users") &&
			this.$store.getters.getRole !== "admin"
		) {
			this.$store.dispatch("accessDenied", this.$t("users"));
			this.$router.push("/");
		}
		if (
			this.$router.currentRoute.path === "/history/projects" &&
			this.$store.getters.getRole !== "admin"
		) {
			this.$store.dispatch("accessDenied", this.$t("activity"));
			this.$router.push("/");
		}
		if (
			this.$router.currentRoute.path.includes("/organism") &&
			this.$store.getters.getRole !== "admin"
		) {
			this.$store.dispatch("accessDenied", this.$t("organisms"));
			this.$router.push("/");
		}
		if (
			this.$router.currentRoute.path.includes("/statistics") &&
			this.$store.getters.getRole !== "legal_auditor"
		) {
			this.$store.dispatch("accessDenied", this.$t("statistics"));
			this.$router.push("/");
		}
		this.$store.getters.getWebsocket.Subscribe(
			"notification.vms-extractions-api.organisms." + userInfo.data.organismId,
			this.arriveSecondaries
		);
	},
	beforeDestroy() {
		this.$store.getters.getWebsocket.Unsubscribe(
			"notification.vms-extractions-api.organisms." +
				this.$store.getters.getUserInfo.organismId,
			this.arriveSecondaries
		);
	},
	components: {
		CoreFooter: () => import("./Footer"),
	},
	computed: {
		windowWidth: {
			get() {
				return this.$store.getters.getWindowWidth;
			},
			set(value) {
				return this.$store.commit("setWindowWidth", value);
			},
		},
	},
	methods: {
		arriveSecondaries(notification) {
			const notficationParsed = JSON.parse(notification.data);
			let notificationMessage = JSON.parse(notficationParsed.Message);
			this.$store.commit("setSecodaryUpdate", notificationMessage);
		},
	},
};
</script>
<style>
.window-a .v-content__wrap {
	margin-left: -50px;
	max-width: 120%;
	animation-duration: 0.5s;
	animation-name: slide;
}
.window-b .v-content__wrap {
	margin-left: 0px;
	max-width: 100%;
	animation-duration: 0.5s;
	animation-name: slideoff;
}
@keyframes slide {
	from {
		margin-left: 0px;
		max-width: 100%;
	}

	to {
		margin-left: -50px;
		max-width: 120%;
	}
}
@keyframes slideoff {
	from {
		margin-left: -50px;
		max-width: 120%;
	}

	to {
		margin-left: 0px;
		max-width: 100%;
	}
}
@media (max-width: 1263px) {
	.window-a .v-content__wrap {
		margin-left: 0px;
		max-width: 100%;
	}
}
</style>
